module.exports = __webpack_public_path__ + "static/media/CSPORT STEREO POWER AMPLIFIER GM70PA.cd87c6a6.png";